document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.section-hoko-special-comparasion__container', {
        slidesPerView: 1.3,
        spaceBetween: 8,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            768: { slidesPerView: 4, spaceBetween: 8 },
        },
    });
});